import { axiosInstance } from "../utils/axiosInstance";

export const GetPlanStatus = async (id) => {
    return await axiosInstance.get(`plan_status/${id}`);
};

export const GetReviveRenewData = (id) =>{
    return axiosInstance.get(`revive_renew_checkout/${id}`);
}